<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <Header msg="Header" />     -->
    <Delivery deliveryFilter="polygon" msg="Delivery" />
    <Footer msg="Footer" />
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
// import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Delivery from "@/components/Delivery.vue";

export default {
  name: "home",
  components: {
    // Header,
    Footer,
    Delivery
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>